"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammaticOpportunityEntity = exports.ProgrammaticCreativeEntity = void 0;
class ProgrammaticCreativeEntity {
    id;
    providerId;
    providerCreativeId;
    contentHash;
    advertiserDomains;
    iabCategories;
    brandIds;
    mediaType;
    mimeType;
    width;
    height;
    durationSeconds;
    reviewStatus;
    validationResult;
    rejectionReason;
    sourceUrl;
    storedMediaId;
    safeDeliveryUrl;
    createdAt;
    updatedAt;
}
exports.ProgrammaticCreativeEntity = ProgrammaticCreativeEntity;
class ProgrammaticOpportunityEntity {
    id;
    displayId;
    scheduledAt;
    expiresAt;
    policySnapshot;
    providerId;
    providerRequestId;
    bidId;
    testPrice;
    testCurrency;
    creativeId;
    deliveryId;
    state;
    latestOutcome;
    retryCount;
    createdAt;
    updatedAt;
}
exports.ProgrammaticOpportunityEntity = ProgrammaticOpportunityEntity;
